import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-style-four',
  templateUrl: './features-style-four.component.html',
  styleUrls: ['./features-style-four.component.scss']
})
export class FeaturesStyleFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
